import React, { useState } from 'react';
import { EditOutlined, InfoCircleOutlined, } from '@ant-design/icons';
import { Space, Button, Input, Form, Tooltip } from 'antd';

const validateMessages = {
  types: {
    url: 'is not valid url'
  }
}

const EditInput = ({
  labelStyle,
  contentStyle,
  value,
  onSubmit,
  inputRef,
  labelValue,
  handleValidate,
  tooltipMessage
}) => {

  const [isDisplay, setDisplay] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handletoggle = () => {
    if (isDisplay) {
      // reset message when close 
      setErrorMessage('')
    }
    setDisplay((currentState) => {
      return !currentState
    })
  }

  const handleSumit = async () => {
    const { current } = inputRef
    if (current && handleValidate) {
      const inputValue = current?.state?.value;
      const { isValid, message } = handleValidate(inputValue);
      setErrorMessage(message);
      if (!isValid) {
        return false
      }
    }

    if (onSubmit) {
      await onSubmit();
    }
    handletoggle()
  }

  const renderLabel = () => {
    return (
      <p style={{ ...labelStyle, marginBottom: errorMessage ? '0.5em' : '1em'}}>
        {labelValue}
        {
          tooltipMessage && <span>
            <InfoCircleOutlined
              style={{
                color: 'rgb(26, 148, 255)',
                fontWeight: 700,
                cursor: 'pointer'
              }}
            />
          </span>
        }
      </p>
    )
  }

  return (
    <div>
      <Space>
        <Tooltip title={tooltipMessage}>
          {renderLabel()}
        </Tooltip>
        {!isDisplay &&
          <p style={contentStyle}>
            {value || ''}
            <span
              onClick={handletoggle}
              style={{
                marginLeft: 15,
                color: 'rgb(26, 148, 255)',
                fontWeight: 700,
                cursor: 'pointer'
              }}>
              <EditOutlined />
            </span>
          </p>}
        {isDisplay &&
          <div style={{ marginBottom: errorMessage ? '0.5em' : '1em' }}>
            <div>
              <Form validateMessages={validateMessages} name="form" onFinish={handleSumit}>
                <Space>

                  <Form.Item
                    rules={[{ type: 'url' }]}
                    noStyle={true}
                    help={errorMessage}
                    validateStatus={errorMessage ? 'error' : ''}
                  >
                    <Input
                      required
                      ref={inputRef}
                      style={{
                        width: 240,
                        border: errorMessage && '1px solid red'
                      }}
                      defaultValue={value || ''}
                      id={errorMessage ? 'error' : ''}
                    />

                  </Form.Item>
                  <Button htmlType="submit" size="small" type="primary">Save</Button>
                  <Button onClick={handletoggle} size="small">Cancel</Button>
                </Space>
              </Form>
            </div>
          </div>
        }
      </Space>
      <br/>
      {isDisplay && errorMessage && <Space>
        <div style={{ ...labelStyle, visibility: 'hidden' }}>
          {renderLabel()}
        </div>
        <p style={{ color: 'red' }}>{errorMessage}</p>
      </Space>}
    </div>
  )
}

export default EditInput